<template>
    <div class="information">
        <home-nav></home-nav>
        <div class="information-tab">
            <ul class="information-ul">
                <li class="information-li" @click="liClick(1)" :class="{'li-active': currentLi == 1}">
                    旅游包车
                </li>
                <li class="information-line"></li>
                <li class="information-li" @click="liClick(2)" :class="{'li-active': currentLi == 2}">
                    大巴包车
                </li>
            </ul>
        </div>

        <div class="information-carousel">
            <div class="information-carousel-box">
                <div class="information-carousel-left">
                    <img class="information-carousel-img" src="@/assets/images/information/news_img_lytitle.png" alt="">
                    <img class="information-carousel-step" src="@/assets/images/information/news_img_bg01.png" alt="">

                    <el-form class="offer-box-form" ref="form" :model="form">
                        <el-form-item>
                            <el-col :span="23">
                                <el-cascader
                                        style="width: 100%;"
                                        placeholder="出发城市"
                                        :options="options"
                                        filterable
                                        v-model="form.startCity"
                                        @change="startChange"
                                >
                                </el-cascader>
                            </el-col>
                        </el-form-item>

                        <el-form-item>
                            <el-col :span="23">
                                <el-input v-model="form.username"
                                          placeholder="您的姓名"
                                >

                                </el-input>
                            </el-col>
                        </el-form-item>

                        <el-form-item>
                            <el-col :span="23">
                                <el-input v-model="form.telephone"
                                          placeholder="您的手机号码"
                                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                                          maxlength="11"
                                >

                                </el-input>
                            </el-col>
                        </el-form-item>

                        <el-form-item class="bottom-btn">
                            <el-col :span="23">
                                <el-button type="danger" @click="onSubmitBtn">计算报价</el-button>
                            </el-col>
                        </el-form-item>
                    </el-form>

                </div>
                <div class="information-carousel-right">
                    <img @click="articleClick(firstId,firstCateId)" :src="firstInfoImg" alt="">
                </div>
            </div>
        </div>

        <div class="ad-box">
            <div class="ad-box-left" @click="toPage(1)">
                <img src="@/assets/images/information/news_img_fz01.png" alt="">
            </div>
            <div class="ad-box-right" @click="toPage(2)">
                <img src="@/assets/images/information/news_img_fz02.png" alt="">
            </div>
        </div>

        <div class="information-article">
            <div class="article-left">
                <div class="article-left-box">
                    <div class="article-list"
                         v-for="(item,index) in articleList"
                         :key="index"
                         @click="articleClick(item.id,item.cate_id)"
                    >
                        <img class="article-list-img" :src="item.img ? item.img : morenShoutu" alt="">
                        <p class="article-list-title">
                            {{ item.title }}
                        </p>
                        <div class="article-list-detail">
                            <div class="detail-left">
                                <img src="@/assets/images/information/news_icon_ren.png" alt="">
                                <span>{{ item.author }}</span>
                            </div>
                            <div class="detail-right">
                                <img src="@/assets/images/information/news_icon_ril.png" alt="">
                                <span>{{ item.created_at }}</span>
                            </div>
                        </div>
                        <div class="article-list-content">
                            {{ item.synopsis }}
                        </div>
                        <div class="article-list-more">
                            <span @click="readMore(item.id)">阅读更多</span>
                        </div>
                    </div>
                </div>
                <el-pagination
                        v-show="articleList.length"
                        class="el-pagination-car"
                        @size-change="handleSizeChange"
                        @current-change="currentPageChange"
                        :current-page.sync="currentPage"
                        layout="prev, pager, next, jumper"
                        :page-size="pagesize"
                        :pager-count="5"
                        :total="allNum"
                >
                </el-pagination>

                <!--暂无文章-->
                <div v-show="!articleList.length" class="zanwuWenzhang">
                    <img src="@/assets/images/information/null_img_search.png" alt="">
                    <span>没有找到相关内容，换个词搜索试试吧</span>
                </div>
            </div>
            <div class="article-right">
                <div class="article-right-search">
                    <el-input
                            placeholder="请输入内容"
                            v-model="input2"
                    >
                        <i class="el-icon-search el-input__icon"
                           style="color: #FF5227;"
                           slot="suffix"
                           @click="onInputBlur">
                        </i>
                    </el-input>
                </div>

                <div class="article-right-future">
                    <p class="article-right-future-p">
                        <span class="article-right-future-span">热点资讯</span>
                        <span class="article-right-future-span-two">查看更多</span>
                    </p>
                    <ul class="article-right-future-ul">
                        <li class="article-right-future-li"
                            v-for="(item,index) in futureListTwo"
                            :key="index"
                            @click="articleClick(item.id,item.cate_id)"
                        >
                            <div class="li-title">
                                · {{ item.title }}
                            </div>
                            <div class="li-time">
                                {{ item.created_at }}
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="article-right-future">
                    <p class="article-right-future-p">
                        <span class="article-right-future-span">近期新闻</span>
                        <span class="article-right-future-span-two">查看更多</span>
                    </p>
                    <ul class="article-right-future-ul">
                        <li class="article-right-future-li"
                            v-for="(item,index) in futureList"
                            :key="index"
                            @click="articleClick(item.id,item.cate_id)"
                        >
                            <div class="li-title">
                                · {{ item.title }}
                            </div>
                            <div class="li-time">
                                {{ item.created_at }}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!--底部-->
        <home-footer></home-footer>
        <left-code></left-code>
        <right-list></right-list>
    </div>
</template>

<script>
    import homeNav from '@/components/homeNav';
    import homeFooter from '@/components/homeFooter';

    import LeftCode from '@/components/leftCode';
    import RightList from "@/components/rightList";

    import { mapMutations, mapGetters} from 'vuex';

    export default {
        name: "informationcharter",
        components: {
            homeNav,
            homeFooter,
            LeftCode,
            RightList
        },
        computed: {
            ...mapGetters(['getuserIp'])
        },
        data() {
            return {
                currentLi: 2,
                allNum: 1,
                form: {
                    startCity: [], //出发城市
                    username: '', //姓名
                    telephone: '', //手机号码
                },
                options: [],
                shaindex: '',

                currentPage: 1,
                pagesize: 6,
                articleList: [],

                input2: '',
                futureList: [],
                futureListTwo: [],
                firstInfoImg: '',
                firstId: '',
                firstCateId: '',

                worldCharter: '',
                morenShoutu: require('@/assets/images/information/public_img_imgshibai.png')
            }
        },
        mounted() {
            window.scrollTo(0, 0);
            var that = this;
            that.getInfomation();
            that.getInfomationThree();
            that.getCityOptions();
            that.worldCharter = that.$route.params.word;
            // if (that.worldCharter) {
            //     that.input2 = that.worldCharter;
            //     that.getInfomationKeyWord();
            // } else {
            //     that.getInfomationTwo();
            // }

            this.getUrl();
        },
        methods: {
            ...mapMutations(['saveArticleId']),
            getUrl(){
                var now_url = localStorage.getItem('now_url');
                if(now_url == '' || now_url == undefined || now_url == null){
                    var url = window.location.href;
                    localStorage.setItem('now_url', url);
                }
            },
            getCityOptions() {
                var that = this;
                that.$axios.get('/provinceAndCity', {}).then((res) => {
                    res = res.data;
                    // console.log(res)
                    if (res.status == 200) {
                        that.options = res.data;
                    } else {
                        layer.msg('系统错误，请刷新！', {icon: 2});
                    }
                }).catch((error) => {
                    // console.log(error);
                });
            },
            startChange() {
                // var startCity = this.form.startCity[1];
            },
            liClick(idx) {
                if(idx == this.currentLi){
                    return
                } else {
                    this.$router.push({path: '/information'});
                }
                /*this.currentLi = idx;
                this.currentPage = 1;
                this.getInfomation();
                this.getInfomationThree();*/
            },
            onSubmitBtn() {
                var that = this;
                var userIp = that.getuserIp;
                var url = localStorage.getItem('now_url');

                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (that.form.startCity == undefined || that.form.startCity.length <= 0) {
                    layer.msg('出发城市不能为空~', {icon: 2});
                    return;
                }
                if (that.form.telephone == undefined || that.form.telephone.length <= 0) {
                    layer.msg('手机号码不能为空~', {icon: 2});
                    return;
                }

                if (!myreg.test(that.form.telephone)) {
                    layer.msg('请输入正确的手机号码！', {
                        icon: 2
                    });
                    return;
                }

                if (!myreg.test(that.form.telephone)) {
                    layer.msg('请输入正确的手机号码！', {
                        icon: 2
                    });
                    return;
                }
                var index;
                layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });

                that.$axios.post('/CalculateQuotation', {
                    start_city: that.form.startCity[1],
                    end_city: '',
                    source: "pc",
                    mobile: that.form.telephone,
                    username: that.form.username,
                    people_num: '',
                    url: url,
                    info_id: userIp
                }).then((res) => {
                    layer.closeAll();
                    res = res.data;
                    if (res.status == 200) {
                        that.form.telephone = '';
                        that.form.username = '';
                        layer.msg('提交成功，请耐心等待电话！', {icon: 1});
                    } else {
                        layer.msg('网络异常，请刷新！', {icon: 2});
                    }

                }).catch((error) => {
                    layer.closeAll();
                    // console.log(error);
                });
            },
            toPage(idx) {
                if (idx == 1) {
                    this.$router.push({path: '/offer'});
                } else if (idx == 2) {
                    this.$router.push({path: '/helpcenter'});
                }
            },
            readMore(articleId) {
                console.log(articleId);
            },

            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            currentPageChange(val) {
                this.getInfomation();
            },
            articleClick(id, cate_id) {
                var cidgid=id+"_"+cate_id;
                // console.log(cidgid)
                this.$router.push({name:"InformationDetails",params:{cidgid:cidgid+".html"}});
                this.saveArticleId({'articleType': id, 'articleId': cate_id});//保存文章id

                // this.$router.push({path: "/informationDetails", query: {id: id, cate_id: cate_id}});
                // this.saveArticleId({'articleType': id, 'articleId': cate_id});//保存文章id
            },
            getInfomation() {
                var that = this;
                var index;
                /*layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });*/
                that.$axios.post("/informationList", {
                    cate_id: that.currentLi,
                    page: that.currentPage,
                    sign_text: '',
                    issix: 1,
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        // layer.closeAll();
                        that.articleList = res.data.data;
                        that.allNum = res.data.allNum;
                        if(that.currentPage == 1){
                            that.firstInfoImg = res.data.data[0].img ? res.data.data[0].img : this.morenShoutu;
                        }
                        that.firstId = res.data.data[0].id;
                        that.firstCateId = res.data.data[0].cate_id;
                    } else {
                        // layer.closeAll();
                        // layer.msg(res.message, {icon: 2});
                        this.$message(res.message);
                    }//请求成功返回的数据
                }).catch((error) => {
                    // layer.closeAll();
                    /*layer.msg('系统错误', {
                        icon: 2
                    });*/
                    this.$message('系统错误，请刷新');
                });
            },
            getInfomationTwo() {
                var that = this;
                var cate_id = this.currentLi == 1 ? 2 : 1;
                that.$axios.post("/informationList", {
                    cate_id: cate_id,
                    page: 1,
                    sign_text: this.input2,
                    issix: 1,
                }).then((res) => {
                    // console.log(res);
                    res = res.data;
                    if (res.status == 200) {
                        that.articleList = res.data.data;
                        this.input2 = '';
                    } else {
                        // layer.msg(res.message, {icon: 2});
                        this.$message(res.message);
                    }//请求成功返回的数据
                }).catch((error) => {
                    /*layer.msg('系统错误', {
                        icon: 2
                    });*/
                    this.$message('系统错误');
                });
            },

            // 关键词搜索
            getInfomationKeyWord() {
                var that = this;
                var cate_id = this.currentLi == 1 ? 2 : 1;
                that.$axios.post("/informationList", {
                    cate_id: cate_id,
                    page: 1,
                    sign_text: this.input2,
                    issix: 1,
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        that.articleList = res.data.data;
                    } else {
                        // layer.msg(res.message, {icon: 2});
                        this.$message(res.message);
                    }//请求成功返回的数据
                }).catch((error) => {
                    /*layer.msg('系统错误', {
                        icon: 2
                    });*/
                    this.$message('系统错误');
                });
            },

            getInfomationThree() {
                var that = this;
                var cate_id = this.currentLi == 1 ? 2 : 1;
                that.$axios.post("/informationList", {
                    cate_id: cate_id,
                    page: 1,
                    sign_text: '',
                    issix: 1,
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        that.futureList = res.data.data.slice(0,5);
                        that.futureListTwo = res.data.data.slice(0,4);
                    } else {
                        // layer.msg(res.message, {icon: 2});
                        this.$message(res.message);
                    }//请求成功返回的数据
                }).catch((error) => {
                    /*layer.msg('系统错误', {
                        icon: 2
                    });*/
                    this.$message('系统错误');
                });
            },
            onInputBlur() {
                this.getInfomationTwo();
            },
        }
    }
</script>

<style scoped>
    @import './informationcharter.css';
</style>



// WEBPACK FOOTER //
// src/pages/informationcharter/informationcharter.vue